import React from 'react';
import SortButton from '../toggles/SortButton';
import DarkModeToggle from '../toggles/DarkModeToggle';
import ViewToggle from '../toggles/ViewToggle';
import MarqueeToggle from '../toggles/MarqueeToggle';
import RealTimeToggle from '../toggles/RealTimeToggle';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './tooltip';
import { Separator } from './separator';

const Tip = ({ label, children }) => (
  <Tooltip>
    <TooltipTrigger asChild>{children}</TooltipTrigger>
    <TooltipContent side="bottom">{label}</TooltipContent>
  </Tooltip>
);

const HeaderControls = ({
  sortDescending,
  toggleSort,
  darkMode,
  toggleDarkMode,
  isMosaicView,
  toggleView,
  showMarquee,
  toggleShowMarquee,
  isRealTime,
  toggleRealTime
}) => {
  return (
    <TooltipProvider delayDuration={300}>
      <div className="flex flex-wrap justify-center lg:justify-end items-center gap-1.5 sm:gap-2">
        <div className="hidden md:flex items-center gap-1.5 sm:gap-2">
          <Tip label={isMosaicView ? "Vista lista" : "Vista mosaico"}>
            <span><ViewToggle isMosaicView={isMosaicView} onToggle={toggleView} /></span>
          </Tip>
          <Tip label={sortDescending ? "Orden ascendente" : "Orden descendente"}>
            <span><SortButton sortDescending={sortDescending} onToggle={toggleSort} /></span>
          </Tip>
          <Separator orientation="vertical" className="h-6" />
        </div>
        <div className="flex md:hidden">
          <SortButton sortDescending={sortDescending} onToggle={toggleSort} />
        </div>
        <Tip label={darkMode ? "Modo claro" : "Modo oscuro"}>
          <span><DarkModeToggle darkMode={darkMode} toggleDarkMode={toggleDarkMode} /></span>
        </Tip>
        <Tip label={showMarquee ? "Ocultar ticker" : "Mostrar ticker"}>
          <span><MarqueeToggle showMarquee={showMarquee} onToggle={toggleShowMarquee} /></span>
        </Tip>
        <Separator orientation="vertical" className="h-6" />
        <Tip label={isRealTime ? "Desactivar tiempo real" : "Activar tiempo real"}>
          <span><RealTimeToggle isRealTime={isRealTime} onToggle={toggleRealTime} /></span>
        </Tip>
      </div>
    </TooltipProvider>
  );
};

export default HeaderControls;
